import React from 'react';

import { NotProvided } from './not-provided';
import { ValueDisplay } from './value-display';

interface FuneralArrangement {
  disposition?: string;
  burialLocation?: string;
  funeralHome?: string;
  casketType?: string;
  burialMarker?: string;
  cremationFacility?: string;
  cremationDetails?: string;
  embalming?: string;
  ashesDisposition?: string;
  ashInstructions?: string;
  urnType?: string;
  urnDetails?: string;
  donationDetails?: string;
}

interface FuneralDispositionDisplayProps {
  funeralArrangement: FuneralArrangement;
}

const formatDispositionValue = (disposition: string) => {
  const dispositionMap: Record<string, string> = {
    'burial': 'Burial',
    'cremation': 'Cremation',
    'donation': 'Body Donation',
    'no-preference': 'No Preference'
  };
  return dispositionMap[disposition] || disposition;
};

export function FuneralDispositionDisplay({ funeralArrangement }: FuneralDispositionDisplayProps) {
  const { disposition } = funeralArrangement;

  if (!disposition) {
    return <NotProvided />;
  }

  const formattedDisposition = formatDispositionValue(disposition);

  return (
    <div className="funeral-disposition-display">
      <div className="value-display-container">
        <ValueDisplay label="Disposition Method" value={formattedDisposition} />
      </div>

      {disposition === 'burial' && (
        <>
          <div className="value-display-container">
            <ValueDisplay 
              label="Burial Location" 
              value={funeralArrangement.burialLocation || ''} 
            />
            <ValueDisplay 
              label="Funeral Home" 
              value={funeralArrangement.funeralHome || ''} 
            />
          </div>
          <div className="value-display-container">
            <ValueDisplay 
              label="Casket Type" 
              value={funeralArrangement.casketType || ''} 
            />
            <ValueDisplay 
              label="Burial Marker" 
              value={funeralArrangement.burialMarker || ''} 
            />
          </div>
        </>
      )}

      {disposition === 'cremation' && (
        <>
          <div className="value-display-container">
            <ValueDisplay 
              label="Cremation Facility" 
              value={funeralArrangement.cremationFacility || ''} 
            />
            <ValueDisplay 
              label="Embalming" 
              value={funeralArrangement.embalming || ''} 
            />
          </div>
          <div className="value-display-container">
            <ValueDisplay 
              label="Ashes Disposition" 
              value={funeralArrangement.ashesDisposition || ''} 
            />
            <ValueDisplay 
              label="Urn Type" 
              value={funeralArrangement.urnType || ''} 
            />
          </div>
          {funeralArrangement.cremationDetails && (
            <div className="value-display-container">
              <ValueDisplay 
                label="Cremation Details" 
                value={funeralArrangement.cremationDetails} 
              />
            </div>
          )}
          {funeralArrangement.ashInstructions && (
            <div className="value-display-container">
              <ValueDisplay 
                label="Ash Instructions" 
                value={funeralArrangement.ashInstructions} 
              />
            </div>
          )}
          {funeralArrangement.urnDetails && (
            <div className="value-display-container">
              <ValueDisplay 
                label="Urn Details" 
                value={funeralArrangement.urnDetails} 
              />
            </div>
          )}
        </>
      )}

      {disposition === 'donation' && funeralArrangement.donationDetails && (
        <div className="value-display-container">
          <ValueDisplay 
            label="Donation Details" 
            value={funeralArrangement.donationDetails} 
          />
        </div>
      )}
    </div>
  );
}
